// src/utils/countryMapESEN.js
/**
 * A mapping object that translates country names from Spanish to English.
 *
 * Each key in the object represents the country's name in Spanish, and its corresponding value is the country's name in English.
 *
 * This variable is useful for applications that require bilingual representations of country names, such as in multilingual interfaces or translation services.
 */
const countryMapESEN = {
    'España': 'Spain',
    'Francia': 'France',
    'Alemania': 'Germany',
    'Italia': 'Italy',
    'Portugal': 'Portugal',
    'Reino Unido': 'United Kingdom',
    'Estados Unidos': 'United States',
    'México': 'Mexico',
    'Argentina': 'Argentina',
    'Brasil': 'Brazil',
    'Canadá': 'Canada',
    'Rusia': 'Russia',
    'China': 'China',
    'Japón': 'Japan',
    'India': 'India',
    'Australia': 'Australia',
    'Sudáfrica': 'South Africa',
    'Egipto': 'Egypt',
    'Turquía': 'Turkey',
    'Chile': 'Chile',
    'Colombia': 'Colombia',
    'Perú': 'Peru',
    'Venezuela': 'Venezuela',
    'Uruguay': 'Uruguay',
    'Paraguay': 'Paraguay',
    'Bolivia': 'Bolivia',
    'Ecuador': 'Ecuador',
    'Guatemala': 'Guatemala',
    'Cuba': 'Cuba',
    'Suecia': 'Sweden',
    'Noruega': 'Norway',
    'Finlandia': 'Finland',
    'Dinamarca': 'Denmark',
    'Polonia': 'Poland',
    'Grecia': 'Greece',
    'Suiza': 'Switzerland',
    'Austria': 'Austria',
    'Bélgica': 'Belgium',
    'Países Bajos': 'Netherlands',
    'Irlanda': 'Ireland',
    'Hungría': 'Hungary',
    'Rumanía': 'Romania',
    'Chequia': 'Czechia',
    'Eslovaquia': 'Slovakia',
    'Croacia': 'Croatia',
    'Serbia': 'Serbia',
    'Bulgaria': 'Bulgaria',
    'Eslovenia': 'Slovenia',
    'Ucrania': 'Ukraine',
    'Bielorrusia': 'Belarus',
    'Lituania': 'Lithuania',
    'Letonia': 'Latvia',
    'Estonia': 'Estonia',
    // Agrega más países según lo necesites
};

export default countryMapESEN;
